import { BodyBackdropActions } from './backdrop.enum';
import { RemoveBodyBackdrop, SetBodyBackdrop } from './backdrop.interface';

export function setBodyBackdrop(): SetBodyBackdrop {
  return {
    isBodyBackdropVisible: true,
    type: BodyBackdropActions.SET_BODY_BACKDROP,
  };
}

export function removeBodyBackdrop(): RemoveBodyBackdrop {
  return {
    isBodyBackdropVisible: false,
    type: BodyBackdropActions.REMOVE_BODY_BACKDROP,
  };
}
